import { Navigate, Route, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import LowToHigh from "./components/LowToHigh";
import OptionHero from "./components/OptionHero";
import SearchPage from "./components/SearchPage";
import HighToLow from "./components/HighToLow";
import AZ from "./components/A-Z";
import ZA from "./components/ZA";
import LoginPage from "./components/LoginPopup";
import Signup from "./components/Signup";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import "./css/style.css";

function App() {
  const { currentUser } = useContext(AuthContext);

  const RequireAuth = ({ children }) => {
    return currentUser ? children : <Navigate to={"/login"} />;
  };
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route
          path="/restaurant"
          element={
            <RequireAuth>
              <SearchPage />
            </RequireAuth>
          }
        />
        <Route path="/sorted/htl" element={<HighToLow />} />
        <Route path="/sorted/lth" element={<LowToHigh />} />
        <Route path="/sorted/az" element={<AZ />} />
        <Route path="/sorted/za" element={<ZA />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Signup />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
